export default __webpack_public_path__ + "static/award_pc_mag-6c2fb0b4b9480b3477df78abf2f008d0.png";